import styled from "styled-components"


export const CustomizeGoalWrapper = styled.div`
  height: calc(100% - var(--app-cta-height));
  display: flex;
  flex-direction: column;
  gap: 16px;

  display: flex;
  padding: var(--spacing_xl, 24px) var(--app-horizontal-padding) 0px var(--app-horizontal-padding);
  flex-direction: column;
  padding-bottom: 16px;
  overflow-y: auto;
`

export const CustomizeGoalTitle = styled.h1`
  font-size: 20px;
  font-weight: 800;
  line-height: 120%;
`
export const CustomizeGoalSubtitle = styled.p`
  font-size: 14px;
  line-height: 160%;
  color: var(--Primitive-White_80, rgba(255, 255, 255, 0.8));
`

export const CaloriesInputBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const CaloriesInputHint = styled.p<{ $isError?: boolean }>`
  font-size: 14px;
  line-height: 160%; /* 22.4px */
  color: ${(props) =>
    props.$isError
      ? "var(--Schemes-Brand-color-Secondary, #FFC800)"
      : "var(--Primitive-White_80, rgba(255, 255, 255, 0.80))"};
  text-align: right;
`

export const Divider = styled.div`
  background: var(--Primitive-White_10, rgba(255, 255, 255, 0.1));
  height: 1px;
  width: calc(100% - 16px);
  margin: 16px auto;
`
